import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';
import appConfig from "../../app.config";
//import SubscriptionService from "../services/SubscriptionService";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Correction du routeur
router.beforeEach(async (routeTo, routeFrom, next) => {
  // Instance du service
 // let subscriptionService = new SubscriptionService();

  /*// 1. Gérer la redirection des utilisateurs sans abonnement
  // On s'assure que l'utilisateur n'est pas déjà sur la page "sans abonnement" pour éviter une boucle de redirection
  if (routeTo.path !== '/no-subscription' && authRequired) {
    let isSubscribed = await subscriptionService.checkSubscription();
    if (!isSubscribed) {
      return next("/no-subscription"); // Un seul appel à next()
    }
  }*/

  return next();



});

// Supprimer la deuxième garde de navigation si sa logique est déjà gérée dans la première
router.beforeEach((routeTo, routeFrom, next) => {


  next();
});
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  next();
});

export default router;
